// Implements: F-RPT-006, F-UIX-018
/**
 * Owner 2026-10-19: "Latencia y errores por modelo y paso" of the organization on its Consumo
 * screen, the card Plataforma > Estado draws (v3 `:1916-1919`) for the org admin's own
 * organization: a head with the window, its period ("Este mes" / "Últimos 7 días", owner 2026-10-19
 * answer 8A, as on Estado) and the export, then the body the container chose (the table, the
 * loading, empty or error state). Pure presentation.
 */

import { useId } from "react";
import type { ReactElement, ReactNode } from "react";

import { useTranslation } from "../../../shared/i18n";
import styles from "./OrgLatency.module.css";

export interface OrgLatencyProps {
  /** The window the section shows, as the person reads it. */
  readonly range: string;
  /** The period's choice, beside the window it names. */
  readonly period: ReactNode;
  /** The section's actions ("Exportar CSV"). */
  readonly actions: ReactNode;
  readonly children: ReactNode;
}

export function OrgLatency({ range, period, actions, children }: OrgLatencyProps): ReactElement {
  const { t } = useTranslation();
  const headingId = useId();
  return (
    <section className={styles.card} aria-labelledby={headingId}>
      <div className={styles.head}>
        <div className={styles.titles}>
          <h3 id={headingId} className={styles.title}>
            {t("reports.latency.title")}
          </h3>
          <p className={styles.meta}>{range}</p>
        </div>
        <div className={styles.period}>{period}</div>
        {actions}
      </div>
      {children}
    </section>
  );
}
